export type VersionBump = 'bugfix' | 'minor' | 'major';

const versionTagPattern = /^v(\d+)\.(\d+)\.(\d+)$/;

export const parseVersionTag = (
  version: string,
): { major: number; minor: number; patch: number } | undefined => {
  const match = version.match(versionTagPattern);

  if (!match) {
    return undefined;
  }

  return {
    major: Number(match[1]),
    minor: Number(match[2]),
    patch: Number(match[3]),
  };
};

export const isVersionTag = (version: string): boolean => !!parseVersionTag(version);

export const bumpVersionTag = (version: string, bump: VersionBump): string | undefined => {
  const parsedVersion = parseVersionTag(version);

  if (!parsedVersion) {
    return undefined;
  }

  if (bump === 'major') {
    return `v${parsedVersion.major + 1}.0.0`;
  }

  if (bump === 'minor') {
    return `v${parsedVersion.major}.${parsedVersion.minor + 1}.0`;
  }

  return `v${parsedVersion.major}.${parsedVersion.minor}.${parsedVersion.patch + 1}`;
};

export const getInitialVersionTag = (bump: VersionBump): string => {
  if (bump === 'major') {
    return 'v1.0.0';
  }

  if (bump === 'minor') {
    return 'v0.1.0';
  }

  return 'v0.0.1';
};

export const compareVersionTags = (left: string, right: string): number | undefined => {
  const leftVersion = parseVersionTag(left);
  const rightVersion = parseVersionTag(right);

  if (!leftVersion || !rightVersion) {
    return undefined;
  }

  const leftParts = [leftVersion.major, leftVersion.minor, leftVersion.patch];
  const rightParts = [rightVersion.major, rightVersion.minor, rightVersion.patch];

  for (let index = 0; index < 3; index += 1) {
    const leftPart = leftParts[index];
    const rightPart = rightParts[index];

    if (leftPart !== rightPart) {
      return leftPart - rightPart;
    }
  }

  return 0;
};
